import { render, staticRenderFns } from "./PaletteTest.vue?vue&type=template&id=631a008c"
import script from "./PaletteTest.vue?vue&type=script&lang=js"
export * from "./PaletteTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports